import { Component, Input, OnInit, inject } from '@angular/core';
import { LiveClass } from '../../shared/core/state/live-class/models/live-class';
import { RecordingUploadSession } from '../../shared/core/models/upload-session.model';
import { LiveClassService } from '../../shared/core/state/live-class/live-class.service';
import { Router } from '@angular/router';
import { CloudUploadService } from '../../shared/core/services/cloud-upload.service';
import { SubscriptionStatus } from '../../shared/core/state/subscription/subscription.model';

@Component({
  selector: 'black-recordings',
  standalone: false,

  templateUrl: './recordings.component.html',
  styleUrl: './recordings.component.css',
})
export class RecordingsComponent implements OnInit {
  private liveClassService = inject(LiveClassService);
  private router = inject(Router);
  private uploadService = inject(CloudUploadService);

  @Input()
  selectedLiveClass: LiveClass | null = null;

  @Input()
  isInstructorView = false;

  recordings: RecordingUploadSession[] = [];

  addRecordingSession(session: RecordingUploadSession) {
    this.recordings.push(session);
  }

  removeRecordingSession(sessionId: string) {
    this.recordings = this.recordings.filter(
      (recording) => recording.sessionId !== sessionId
    );
  }

  ngOnInit(): void {
    this.fetchAllPastRecordings();
  }

  // TODO: replace with proper player (or a popoup)
  playVideo(sessionId: string) {
    this.router.navigate(['past-meetings', 'play', sessionId]);
  }

  fetchAllPastRecordings() {
    if (this.selectedLiveClass && this.selectedLiveClass.id)
      this.liveClassService
        .getAllRecordings(this.selectedLiveClass?.id)
        .subscribe((res) => {
          this.recordings.push(
            ...res.map((recording) => {
              return {
                sessionId: recording._id,
                sessionDate: recording.sessionDate,
                sessionName: recording.sessionName,
                resource: recording.resource,
                liveClass: recording.liveClass,
                meetingId: recording.meetingId,
                uploadSessionId:
                  this.uploadService.getUploadSessionByTrackingId(
                    recording.resource._id
                  )?.id,
              };
            })
          );
        });
  }

  // Check if user has valid active subscription
  hasValidSubscription(): boolean {
    if (!this.selectedLiveClass || this.isInstructorView) {
      return true; // Instructors always have access
    }

    const subscription = this.selectedLiveClass.subscriptions;
    return subscription.some((sub) =>
      [SubscriptionStatus.ACTIVE, SubscriptionStatus.COMPLETE].includes(
        sub.status
      )
    );
  }

  get isAuthorized(): boolean {
    return this.isInstructorView || this.hasValidSubscription();
  }
}
